// Dashboard · Top business opportunities card (gap-area histogram).
import React from "react";
import { Card } from "../ui/card";

export default function TopOpportunitiesCard({ gaps }) {
  return (
    <Card className="card-elevated p-6">
      <div className="overline">Top business opportunities</div>
      <h3 className="font-sans-ui font-semibold text-lg mt-1">Across all leads</h3>
      <div className="mt-5 space-y-4">
        {gaps.length === 0 && <div className="text-sm text-muted-foreground">No data yet.</div>}
        {gaps.map((g) => (
          <div key={g.area}>
            <div className="flex items-center justify-between text-sm">
              <span>{g.area}</span>
              <span className="text-muted-foreground">{g.count}</span>
            </div>
            <div className="h-1.5 bg-secondary mt-2 rounded-full overflow-hidden">
              <div className="h-full bg-accent" style={{ width: `${Math.min(100, g.count * 20)}%` }} />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
